define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var deviceCommon = require('util/device.common.util');

    _.extend(deviceCommon, {
        getAvailableSpace: function() {
            var availableSpace;
            var computedStyle;
            var div = document.createElement('div');
            div.style.width = div.style.height = '100%';
            div.style.position = 'fixed';
            document.body.insertBefore(div, document.body.firstElementChild);
            computedStyle = window.getComputedStyle(div);
            availableSpace = {
                width: parseFloat(computedStyle.width),
                height: parseFloat(computedStyle.height)
            };
            div.remove();

            return availableSpace;
        }
    });

    module.exports = deviceCommon;
});
